import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import type BadgeCriteria from '@linc-technologies/linced-common/models/goals/badge-criteria';
import type BadgeProfile from '@linc-technologies/linced-common/models/goals/badge-profile';

// Proto: goals.BadgeBadge.
export default class BadgeBadge extends Fragment {
  declare [Type]: 'goals/badge-badge';

  // Unique IRI for the Badge
  @attr('string')
  declare badgeId: string | undefined;

  // valid JSON-LD representation of the BadgeClass type.
  // In most cases, this will simply be the string BadgeClass.
  // "BadgeClass"
  @attr('string', { defaultValue: '' })
  declare type: string;

  // The name of the achievement.
  @attr('string', { defaultValue: '' })
  declare name: string;

  // A short description of the achievement.
  @attr('string', { defaultValue: '' })
  declare description: string;

  // IRI of an image representing the achievement. May be a Data URI, or URI
  // where the image may be found.
  @attr('string', { defaultValue: '' })
  declare image: string;

  //TODO: this is going to need to be addressed since we will have auth on our image serve routes which will stop third parties from requesting images.
  // Embedded criteria document describing how to earn the achievement.
  @fragment('goals/badge-criteria')
  declare criteria: BadgeCriteria | null;

  // Document describing the individual, entity, or organization that issued
  // the badge.
  @fragment('goals/badge-profile')
  declare issuer: BadgeProfile | null;
}
